import React from "react";
import { useTheme } from "../context/ThemeContext";
import { cn } from "../lib/utils";

/**
 * UnitedCloud logo. Automatically swaps light/dark artwork based on the current theme.
 */
export default function BrandLogo({ variant = "full", className = "", ...rest }) {
  const { mode } = useTheme();
  // Resolve effective theme (system → OS preference)
  const isDark =
    mode === "dark" ||
    (mode === "system" &&
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-color-scheme: dark)").matches);

  const src = isDark ? "/logos/unitedcloud-dark.png" : "/logos/unitedcloud-light.png";
  return (
    <img
      src={src}
      alt="UnitedCloud"
      className={cn("object-contain", className)}
      {...rest}
    />
  );
}
